import _possibleConstructorReturn from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { map } from 'rxjs/operators';
export var InputEventHandler =
/*#__PURE__*/
function () {
  function InputEventHandler(videoElement, controlService, eventSource, options) {
    var _this = this;

    _classCallCheck(this, InputEventHandler);

    this.videoElement = videoElement;
    this.controlService = controlService;
    this.eventSource = eventSource;
    this.options = options;
    this.onMouseButton = this.onMouseButton.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onZoom = this.onZoom.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onKey = this.onKey.bind(this);
    this.eventSource.mouseButton$.pipe(map(function (data) {
      var pos = _this.getRelativePosition(data.x, data.y);

      data.x = pos.x;
      data.y = pos.y;
      return data;
    })).subscribe(this.onMouseButton);
    this.eventSource.mouseMove$.pipe(map(function (data) {
      var pos = _this.getRelativePosition(data.x, data.y);

      data.x = pos.x;
      data.y = pos.y;
      return data;
    })).subscribe(this.onMouseMove);
    this.eventSource.zoom$.subscribe(this.onZoom);
    this.eventSource.focus$.subscribe(this.onFocus);
    this.eventSource.key$.subscribe(this.onKey);
  }

  _createClass(InputEventHandler, [{
    key: "onMouseButton",
    value: function onMouseButton(data) {}
  }, {
    key: "onMouseMove",
    value: function onMouseMove(data) {}
  }, {
    key: "onFocus",
    value: function onFocus(focus) {
      this.controlService.reset();
    }
  }, {
    key: "onZoom",
    value: function onZoom(data) {
      this.controlService.zoom(data.delta);
    }
  }, {
    key: "onKey",
    value: function onKey(data) {
      if (data.keyDown) {
        this.controlService.keyDown(data.key);
      } else {
        this.controlService.keyUp(data.key);
      }
    }
  }, {
    key: "getRelativePosition",
    value: function getRelativePosition(x, y) {
      var video = this.videoElement;
      var ratioX = video.videoWidth / video.clientWidth;
      var ratioY = video.videoHeight / video.clientHeight;
      var newX = Math.max(0, Math.min(video.videoWidth, x * ratioX));
      var newY = Math.max(0, Math.min(video.videoHeight, y * ratioY));
      return {
        x: newX,
        y: newY
      };
    }
  }, {
    key: "getRelativeDelta",
    value: function getRelativeDelta(x, y) {
      var video = this.videoElement;
      var ratioX = video.videoWidth / video.clientWidth;
      var ratioY = video.videoHeight / video.clientHeight;
      return {
        x: x * ratioX,
        y: y * ratioY
      };
    }
  }]);

  return InputEventHandler;
}();
export var InteractionInputEventHandler =
/*#__PURE__*/
function (_InputEventHandler) {
  _inherits(InteractionInputEventHandler, _InputEventHandler);

  function InteractionInputEventHandler(videoElement, controlService, eventSource, options) {
    var _this2;

    _classCallCheck(this, InteractionInputEventHandler);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InteractionInputEventHandler).call(this, videoElement, controlService, eventSource, options));
    _this2.mouseButtonStates = {};
    _this2.mouseMove = false;
    _this2.enableHover = false;
    _this2.lasttime = 0;
    _this2.enableHover = !!_this2.options.interactiveHover;
    return _this2;
  }

  _createClass(InteractionInputEventHandler, [{
    key: "onFocus",
    value: function onFocus(_) {
      _get(_getPrototypeOf(InteractionInputEventHandler.prototype), "onFocus", this).call(this, _);

      this.mouseButtonStates = {};
      this.mouseMove = false;
    }
  }, {
    key: "onMouseButton",
    value: function onMouseButton(data) {
      if (data.buttonDown) {
        this.controlService.mouseDown(data.x, data.y, data.button, false);
      } else {
        this.controlService.mouseUp(data.x, data.y, data.button, false);
      }

      this.mouseButtonStates[data.button] = data.buttonDown;
      var buttonDown = this.hasButtonDown();
      this.mouseMove = buttonDown;
    }
  }, {
    key: "hasButtonDown",
    value: function hasButtonDown() {
      return Object.entries(this.mouseButtonStates).some(function (s) {
        return s[1];
      });
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(data) {
      if (this.mouseMove || this.enableHover) {
        var now = Date.now();

        if (now - this.lasttime > 10) {
          this.controlService.move(data.x, data.y, false);
          this.lasttime = now;
        }
      }
    }
  }]);

  return InteractionInputEventHandler;
}(InputEventHandler);
export var LockingInputEventHandler =
/*#__PURE__*/
function (_InputEventHandler2) {
  _inherits(LockingInputEventHandler, _InputEventHandler2);

  function LockingInputEventHandler(videoElement, controlService, eventSource, options) {
    var _this3;

    _classCallCheck(this, LockingInputEventHandler);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(LockingInputEventHandler).call(this, videoElement, controlService, eventSource, options));
    _this3.mouseButtonStates = {};
    _this3.lasttime = 0;
    _this3.distanceX = 0;
    _this3.distanceY = 0;
    return _this3;
  }

  _createClass(LockingInputEventHandler, [{
    key: "onFocus",
    value: function onFocus(_) {
      _get(_getPrototypeOf(LockingInputEventHandler.prototype), "onFocus", this).call(this, _);

      this.mouseButtonStates = {};
      this.distanceX = 0;
      this.distanceY = 0;
    }
  }, {
    key: "onMouseButton",
    value: function onMouseButton(data) {
      if (!this.mouseButtonStates[data.button]) {
        this.controlService.mouseDown(data.x, data.y, data.button, true);
      } else if (this.mouseButtonStates[data.button] && !data.buttonDown) {
        this.controlService.mouseUp(data.x, data.y, data.button, true);
      }

      this.mouseButtonStates[data.button] = data.buttonDown;
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(data) {
      var now = Date.now();

      if (data.delta) {
        this.distanceX += data.deltaX;
        this.distanceY += data.deltaY;
      }

      if (now - this.lasttime > 10) {
        if (data.delta) {
          var toMove = this.getRelativeDelta(this.distanceX, this.distanceY);
          this.distanceX = 0;
          this.distanceY = 0;
          this.controlService.move(toMove.x, toMove.y, data.delta);
        } else {
          this.controlService.move(data.x, data.y, data.delta);
        }

        this.lasttime = now;
      }
    }
  }]);

  return LockingInputEventHandler;
}(InputEventHandler);